module.exports = __webpack_public_path__ + "img/load-rawk-2.c66ad3af.gif";